
// src/services/axiosInstance.ts
import { toast } from 'react-toastify'; 
import axios from 'axios';
import { getRuntimeConfig } from '../config/RuntimeConfig';
// import { useNavigate } from 'react-router-dom';


export const baseURL = axios.create({
  validateStatus: (status) => status >= 200 && status < 500,
});
let RuntimeApiInitialized = false;
baseURL.interceptors.request.use(
  (config) => {
    if (!RuntimeApiInitialized) {
      const runtimeConfig = getRuntimeConfig();
      baseURL.defaults.baseURL = runtimeConfig.REACT_APP_API_BASE_URL;
      RuntimeApiInitialized = true;
    }
    return AttachTokenFunc(config);
  },
  (error) => Promise.reject(error)
);

//  const navigate = useNavigate();
baseURL.interceptors.request.use(
  
  (config) => {
   
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["PublicAccessKey"] = `M6xllqDpZRpH4HBERkxGjexMWTZ9Ql4F`;
 
    }

   
    const preferredLanguage = localStorage.getItem("language") || "en"; 
    config.headers["Accept-Language"] = preferredLanguage;

    return config;
  },
  (error) => Promise.reject(error) 
);

baseURL.interceptors.response.use(
  (response) => response, // Return the response if it is successful
  (error) => {
    console.log(error);
    if (error.response && error.response.status === 401) {
     
      localStorage.removeItem('accessToken');
      toast.error('Session expired, please log in again');
      // window.location.href = '/login'; // Redirect to login page, or use navigate('/login') if using React Router
     
     
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }
    
    if (error.response && error.response.status === 422) {
     
      localStorage.removeItem('accessToken');
      toast.error('Your access has been revoked. Please contact support for assistance.');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }

    // Optionally, handle other errors (e.g., network errors, timeouts)
    if (error.code === 'ECONNABORTED') {
      toast.error('Request timed out. Please try again later.');
    }

    return Promise.reject(error); // Reject the error to propagate it
  }
);


const AttachTokenFunc = async (config: any) => {
  const token = sessionStorage.getItem("jwt_token");
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
};



export default baseURL;

